const Skills = () => {
  return (
    <div className="col-lg-12">
      <h4>Languages</h4>
      <ul className="list-group list-group-horizontal">
        <li className="list-group-item skill rounded-pill">Python</li>
        <li className="list-group-item skill rounded-pill">C++</li>
        <li className="list-group-item skill rounded-pill">Javascript</li>
        <li className="list-group-item skill rounded-pill">C#</li>
        <li className="list-group-item skill rounded-pill">SQL</li>
        <li className="list-group-item skill rounded-pill">HTML</li>
        <li className="list-group-item skill rounded-pill">CSS/SASS</li>
      </ul>
      <h4>Web Applications</h4>
      <ul className="list-group list-group-horizontal">
        <li className="list-group-item skill rounded-pill">React.js</li>
        <li className="list-group-item skill rounded-pill">Node.js</li>
        <li className="list-group-item skill rounded-pill">Express</li>
        <li className="list-group-item skill rounded-pill">REST</li>
        <li className="list-group-item skill rounded-pill">Pug/Jade</li>
        <li className="list-group-item skill rounded-pill">MongoDB</li>
        <li className="list-group-item skill rounded-pill">AWS</li>
      </ul>
      <h4>Data Analysis</h4>
      <ul className="list-group list-group-horizontal">
        <li className="list-group-item skill rounded-pill ">Pandas</li>
        <li className="list-group-item skill rounded-pill">NumPy</li>
        <li className="list-group-item skill rounded-pill">Matplotlib</li>
        <li className="list-group-item skill rounded-pill">SeeQ</li>
        <li className="list-group-item skill rounded-pill">Tableau</li>
        <li className="list-group-item skill rounded-pill">JMP</li>
      </ul>
    </div>
  );
};

export default Skills;
